<template>
  <div class="sample-detail-primary-results">
    <h3>Results</h3>
    <div class="input-row">
      <SampleLabelControl :showAverageResults="showAverageResults" />
      <SampleLabelControl :showAverageResults="showAverageResults" />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Cu"
        propName="copper"
        propAverageName="averageCopper"
        :tabindex="112"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Fe"
        propName="iron"
        propAverageName="averageIron"
        :tabindex="114"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Cr"
        propName="chromium"
        propAverageName="averageChromium"
        :tabindex="116"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Al"
        propName="aluminum"
        propAverageName="averageAluminum"
        :tabindex="118"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Si"
        propName="silicon"
        propAverageName="averageSilicon"
        :tabindex="120"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Pb"
        propName="lead"
        propAverageName="averageLead"
        :tabindex="122"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Ca"
        propName="calcium"
        propAverageName="averageCalcium"
        :tabindex="124"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Mg"
        propName="magnesium"
        propAverageName="averageMagnesium"
        :tabindex="126"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Zn"
        propName="zinc"
        propAverageName="averageZinc"
        :tabindex="128"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="P"
        propName="phosphorous"
        propAverageName="averagePhosphorous"
        :tabindex="130"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Mo"
        propName="molybdenum"
        propAverageName="averageMolybdenum"
        :tabindex="132"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="B"
        propName="boron"
        propAverageName="averageBoron"
        :tabindex="134"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Ag"
        propName="silver"
        propAverageName="averageSilver"
        :tabindex="136"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Ni"
        propName="nickel"
        propAverageName="averageNickel"
        :tabindex="138"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Sn"
        propName="tin"
        propAverageName="averageTin"
        :tabindex="140"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="K"
        propName="potassium"
        propAverageName="averagePotassium"
        :tabindex="142"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Na"
        propName="sodium"
        propAverageName="averageSodium"
        :tabindex="144"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Ba"
        propName="barium"
        propAverageName="averageBarium"
        :tabindex="146"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Cd"
        propName="cadmium"
        propAverageName="averageCadmium"
        :tabindex="148"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="Mn"
        propName="manganese"
        propAverageName="averageManganese"
        :tabindex="150"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Ti"
        propName="titanium"
        propAverageName="averageTitanium"
        :tabindex="152"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="V"
        propName="vanadium"
        propAverageName="averageVanadium"
        :tabindex="154"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
    </div>
    <br />
  </div>
</template>
<script>
import SampleLabelControl from '../../shared/SampleLabelControl.vue';
import SampleDetailParticleControl from './OilSampleResultParticleControl.vue';

export default {
  name: 'SampleDetailPrimaryResults',
  props: {
    sampleData: {
      type: Object,
      required: true
    },
    showAverageResults: {
      type: Boolean
    },
    mappings: {
      type: Object,
      required: true
    }
  },
  components: {
    SampleDetailParticleControl,
    SampleLabelControl
  }
};
</script>

<style lang="scss" scoped>
.sample-detail-primary-results {
  .input-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  h3,
  h5 {
    display: inline;
  }
}
</style>
